import React from 'react';
import {
  Grid,
} from '@material-ui/core'
import {
  Widgets as WidgetsIcon,
  CheckBox as CheckBoxIcon,
  FormatListNumbered as FormatListNumberedIcon,
} from '@material-ui/icons';
import Tabs from 'components/CustomTabs/CustomTabs';

import ReactResizeDetector from 'react-resize-detector';

import CoupangPartners from '../../components/CoupangPartners/CoupangPartners';

import LottoMakeNumber from './LottoMakeNumber';
import LottoMakeNumberResult from './LottoMakeNumberResult';
import LottoResult from './LottoResult';

export default class Lotto extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tabs: [
        {
          tabName: "이번주 번호",
          tabIcon: WidgetsIcon,
          path: "/lotto/make_number",
          tabContent: (
            <LottoMakeNumber />
          )
        },
        {
          tabName: "이번주 번호 결과",
          tabIcon: CheckBoxIcon,
          path: "/lotto/make_number_result",
          tabContent: (
            <LottoMakeNumberResult />
          )
        },
        {
          tabName: "당첨 결과",
          tabIcon: FormatListNumberedIcon,
          path: "/lotto/result",
          tabContent: (
            <LottoResult />
          )
        },
      ]
    }
  }

  getTabsValue = () => {
    let idx = this.state.tabs.map((e) => e.path).indexOf(window.location.pathname);
    return idx === -1 ? 0:idx;
  }

  render() {
    return (
      <Grid container>
        <Grid item xs={12}>
          <ReactResizeDetector handleWidth handleHeight>
            {({ width, height }) => <CoupangPartners width={width} height={height} />}
          </ReactResizeDetector>
        </Grid>
        <Grid item xs={12}>
          <Tabs
            title=""
            headerColor="warning"
            value={this.getTabsValue}
            tabs={this.state.tabs}
          />
        </Grid>
      </Grid>
    );
  }
}